import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalDatePicker from "../../../intelws_portal/constructs/modal/ModalDatePicker";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import ModalCommetText from "../../../intelws_portal/constructs/modal/ModalCommentText";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { parseQueryResponseOnFail, parseQueryResponseOnSuccess } from "../../../declarations/common_utils";
import { AxiosResponse } from "axios";
import { Link, useHistory } from "react-router-dom";

import * as urls from "../../Urls";
import { request } from "http";
import { IFormRepr } from "../admin/AdminSettings";
import ModalDropDown from "../../../intelws_portal/constructs/modal/ModalDropDown";
import ModalMultiDropDown from "../../../intelws_portal/constructs/modal/ModalMultiDropDown";

interface IFollowUpInfo {
    id: number,
    uf_user_id: number,
    uf_user_name: string,
    uf_subject: string,
    uf_description: string,
    uf_date: string
}

interface IFetchFormConfig extends AxiosResponse {
    data: {
        data: IFormRepr,
        title: string
    }
}

interface IQuestionData {
    value: string | number | string[] | undefined
}

interface IFormSectionData {
    question_data: IQuestionData[];
}

interface IFormDataRepr {
    sections: IFormSectionData[];
}

export interface IModalLeadFollowUpInfoProps {
    formId: number,
    closeModal?: () => void
}

function ModalForm(props: IModalLeadFollowUpInfoProps) {
    const ENDPOINT = "/api/clientdashboard/";


    const [formConfig, setFormConfig] = React.useState<IFormRepr>({ sections: [] });
    const [formData, setFormData] = React.useState<IFormDataRepr>({ sections: [] });
    const [formTitle, setFormTitle] = React.useState("");

    const [currSection, setCurrSection] = React.useState(0);

    const history = useHistory();

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        $("#formSubmissionModal").on("hidden.bs.modal", clearForm);

        return () => {
            $("#formSubmissionModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        if (props.formId != -1) {
            const queryParams = {
                section: "get_form_config",
                form_id: props.formId.toString()
            }

            const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchFormConfig>

            requestResponse.then((response) => {
                setFormConfig(response.data.data);
                setFormData((_) => {
                    let newFormData = { 
                        sections: response.data.data.sections.map((section) => {
                            return { 
                                question_data: section.questions.map((question) => {
                                    return { value: undefined }
                                })
                            };
                        }) 
                    };
                    return newFormData;
                })
                setFormTitle(response.data.title);
            })
        }

    }, [props.formId])

    function clearForm() {
        setFormConfig({ sections: [] });
        setFormData({ sections: [] });
        setFormTitle("");
        setCurrSection(0);
        props.closeModal?.();
    }

    function renderCurrSectionQuestions() {
        const currSectionFormData = formData.sections[currSection].question_data;
        return formConfig.sections[currSection].questions.map((question, idx) => {
            if (question.type == "radio") {
                let options = ["Select Option", ...question.options as string[]];
                let values = ["", ...question.options as string[]];
                const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
                    setFormData((prevFormData) => {
                        let newFormData = {
                            sections: [...prevFormData.sections]
                        }

                        if (!e.target.value) {
                            newFormData.sections[currSection].question_data[idx].value = undefined;
                        } else {
                            newFormData.sections[currSection].question_data[idx].value = e.target.value;
                        }

                        return newFormData;
                    })
                }
                return (
                    <>
                        <div className="column" key={idx}>
                            <h6> {question.question} (Select One) </h6>
                            <ModalDropDown options={options} values={values} value={currSectionFormData[idx].value as string} onChange={onChange} />
                        </div>
                        <br />
                    </>
                )
            } else if (question.type == "checkbox") {
                let options = [...question.options as string[]];
                let values = [...question.options as string[]];
                const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
                    setFormData((prevFormData) => {
                        let newFormData = {
                            sections: [...prevFormData.sections]
                        }

                        console.log(e.target.selectedOptions);
                        if (e.target.selectedOptions.length == 0) {
                            newFormData.sections[currSection].question_data[idx].value = undefined;
                        } else {
                            newFormData.sections[currSection].question_data[idx].value = Array.from(e.target.selectedOptions, option => option.value);
                        }

                        return newFormData;
                    })
                }
                return (
                    <>
                        <div className="column" key={idx}>
                            <h6> {question.question} (Select One or More) </h6>
                            <ModalMultiDropDown options={options} values={values} value={currSectionFormData[idx].value as string[]} onChange={onChange} />
                        </div>
                        <br />
                    </>
                )
            } else if (question.type == "number") {
                const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                    setFormData((prevFormData) => {
                        let newFormData = {
                            sections: [...prevFormData.sections]
                        }

                        const parsedValue = parseInt(e.target.value);

                        if (!parsedValue) {
                            newFormData.sections[currSection].question_data[idx].value = undefined;
                        } else {
                            newFormData.sections[currSection].question_data[idx].value = parsedValue;
                        }

                        return newFormData;
                    })
                }
                return (
                    <>
                        <div className="column" key={idx}>
                            <h6> {question.question} </h6>
                            <ModalInputText inputType="number" title="" value={currSectionFormData[idx].value as number} onChange={onChange} />
                        </div>
                        <br />
                    </>
                )
            } else if (question.type == "text") {
                const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                    setFormData((prevFormData) => {
                        let newFormData = {
                            sections: [...prevFormData.sections]
                        }

                        if (!e.target.value) {
                            newFormData.sections[currSection].question_data[idx].value = undefined;
                        } else {
                            newFormData.sections[currSection].question_data[idx].value = e.target.value;
                        }

                        return newFormData;
                    })
                }
                return (
                    <>
                        <div className="column" key={idx}>
                            <h6> {question.question} </h6>
                            <ModalInputText title="Enter Answer" value={currSectionFormData[idx].value as string} onChange={onChange} />
                        </div>
                        <br />
                    </>
                )
            } else if (question.type == "paragraph") {
                const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setFormData((prevFormData) => {
                        let newFormData = {
                            sections: [...prevFormData.sections]
                        }

                        if (!e.target.value) {
                            newFormData.sections[currSection].question_data[idx].value = undefined;
                        } else {
                            newFormData.sections[currSection].question_data[idx].value = e.target.value;
                        }

                        return newFormData;
                    })
                }
                return (
                    <>
                        <div className="column" key={idx}>
                            <h6> {question.question} </h6>
                            <ModalCommetText title="" value={currSectionFormData[idx].value as string} placeholder="Enter Answer" onChange={onChange} />
                        </div>
                        <br />
                    </>
                )
            }
        })
    }

    function renderCurrentSection() {
        if (formConfig.sections.length == 0 || formData.sections.length == 0) {
            return null;
        }

        return (
            <>
            <p key="form_section_name">{formConfig.sections[currSection].name}</p>
            {renderCurrSectionQuestions()}
            </>
        )
    }

    function submitCallback() {
        console.log("Submitting Form");
    }
    
    function getModalContent() {
        let saveBtnName = "Next Section";
        let saveBtnDisabled = false;
        let saveBtnCallback = () => setCurrSection(prevCurrSection => prevCurrSection + 1);

        let buttonConfig = [
            {
                buttonName: "Previous",
                inactive: false,
                callback: () => setCurrSection(prevCurrSection => prevCurrSection - 1)
            }
        ]
        
        if (currSection == formConfig.sections.length - 1) {
            saveBtnName = "Save";
            saveBtnCallback = submitCallback;
            saveBtnDisabled = formData.sections.some((section) => {
                return section.question_data.some((question) => {
                    return question.value == undefined;
                });
            });
        }

        if (currSection == 0) {
            buttonConfig[0].inactive = true;
        }

        return (
            <React.Fragment>
                <ModalHeader title={`${formTitle}`} />
                <div className="modal-body">
                    {renderCurrentSection()}
                </div>
                <ModalFooter saveCallback={saveBtnCallback} saveInactive={saveBtnDisabled} disable={false} saveBtnName={saveBtnName} buttonConfig={buttonConfig} />
            </React.Fragment>
        )
    }

    function relativeRender() {
        return <div className="modal fade custom-modal text-center" id="formSubmissionModal" tabIndex={-1}>
                <div className="modal-dialog text-left modal-lg">
                    <div className="modal-content">
                        {getModalContent()}
                    </div>
                </div>
            </div>
    }
    
    return ReactDOM.createPortal(relativeRender(), document.getElementById("modal") as Element);
}

export default ModalForm;